import React, { useState, useEffect } from 'react';
import {
  FaTimes, FaUser, FaSignOutAlt, FaCalendarCheck,
  FaClipboardList, FaTasks, FaProjectDiagram,
  FaUsers, FaUserTie, FaRegSmileBeam, FaMicrophoneAlt,
  FaTachometerAlt, FaFileAlt, FaMapMarkerAlt, FaMapMarkedAlt,
  FaPalette, FaUsersCog, FaBullhorn, FaChartBar,
} from 'react-icons/fa';
import { NavLink, useNavigate } from 'react-router-dom';

const Sidebar = ({ isOpen, onClose }) => {
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
  const [worker, setWorker] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const saved = localStorage.getItem('worker');
    if (saved && saved !== 'undefined') {
      setWorker(JSON.parse(saved));
    }
  }, []);

  const navLinkClass = ({ isActive }) =>
    `flex items-center space-x-3 px-4 py-3 rounded-md transition-all duration-200 ${
      isActive
        ? 'bg-gradient-to-r from-pink-200 to-purple-200 text-purple-900 font-semibold shadow-md'
        : 'text-gray-700 hover:bg-purple-100 hover:text-purple-700'
    }`;

  // Section heading helper
  const SectionHeading = ({ label }) => (
    <li className="pt-3 pb-1">
      <span className="px-2 text-xs font-bold uppercase tracking-widest text-purple-400">
        {label}
      </span>
    </li>
  );

  // Divider helper
  const Divider = () => (
    <li className="my-1">
      <div className="border-t border-purple-100" />
    </li>
  );

  const handleLogout = async () => {
  try {
    const token = localStorage.getItem('token');
    const worker = JSON.parse(localStorage.getItem('worker'));

    if (token && worker?._id) {
      // Update status to offline before clearing token
      await fetch('https://missionmap-lc.onrender.com/api/workers/status', {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({ status: 'offline' }),
      });
    }
  } catch (err) {
    console.error('Status update on logout failed:', err);
  } finally {
    // Always clear and redirect even if API fails
    localStorage.removeItem('worker');
    localStorage.removeItem('token');
    setShowLogoutConfirm(false);
    navigate('/');
  }
};
  useEffect(() => {
    document.body.style.overflow = isOpen ? 'hidden' : 'auto';
  }, [isOpen]);

  // ── Common items every role has ────────────────────────────────────────────
  const CommonItems = () => (
    <>
      {/* <li><NavLink to="/voice-chat"    className={navLinkClass}><FaMicrophoneAlt /><span>Voice Chat</span></NavLink></li> */}
     <li>
  <a
    href="https://uniquefin.lifechangers.space/"
    target="_blank"
    rel="noopener noreferrer"
    style={{
      display: "flex",
      alignItems: "center",
      gap: "10px",
      padding: "10px 15px",
      borderRadius: "8px",
      textDecoration: "none",
      color: "#333",
      fontWeight: "500",
      transition: "all 0.3s ease"
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.background = "linear-gradient(135deg, #ffb6c1, #ff69b4)";
      e.currentTarget.style.color = "#fff";
      e.currentTarget.style.transform = "translateX(5px)";
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.background = "transparent";
      e.currentTarget.style.color = "#333";
      e.currentTarget.style.transform = "translateX(0)";
    }}
  >
    <FaMicrophoneAlt />
    <span>Meeting Room</span>
  </a>
</li>
      <li><NavLink to="/user-face"     className={navLinkClass}><FaRegSmileBeam /><span>Face Attendance</span></NavLink></li>
      <li><NavLink to="/user-attendance" className={navLinkClass}><FaCalendarCheck /><span>My Attendance</span></NavLink></li>
      <li><NavLink to="/user-leave"    className={navLinkClass}><FaClipboardList /><span> My Leave Report</span></NavLink></li>
      <li><NavLink to="/user-profile"  className={navLinkClass}><FaUser /><span>My Profile</span></NavLink></li>
    </>
  );

  const renderMenu = () => {
    if (!worker) return null;

    // ── Developer ────────────────────────────────────────────────────────────
  // ── Developer & Designer (same access) ───────────────────────────────────
if (worker.role === 'Developer' || worker.role === 'Designer') {
  return (
    <>
      <CommonItems />
      <li>
        <NavLink to="/user-tasks" className={navLinkClass}>
          <FaTasks /><span>My Task</span>
        </NavLink>
      </li>
      <li>
        <NavLink to="/user-projects" className={navLinkClass}>
          <FaProjectDiagram /><span>My Project</span>
        </NavLink>
      </li>
    </>
  );
}
    // ── TL ───────────────────────────────────────────────────────────────────
    if (worker.role === 'TL') {
      return (
        <>
          <CommonItems />
          <li><NavLink to="/user-tasks"    className={navLinkClass}><FaTasks /><span>My Task</span></NavLink></li>
          <li><NavLink to="/user-projects" className={navLinkClass}><FaProjectDiagram /><span>My Project</span></NavLink></li>
          <Divider />
          <SectionHeading label="Team" />
          <li><NavLink to="/team-attendance" className={navLinkClass}><FaCalendarCheck /><span>Team Attendance</span></NavLink></li>
          <li><NavLink to="/team-leave"      className={navLinkClass}><FaClipboardList /><span>Team Leave Reports</span></NavLink></li>
          <li><NavLink to="/tl-task-manager"      className={navLinkClass}><FaTasks /><span>Assign Team Task</span></NavLink></li>
          {/* <li><NavLink to="/pl-projects"   className={navLinkClass}><FaProjectDiagram /><span>Team Project Tracking</span></NavLink></li> */}
        </>
      );
    }

    // ── Marketing ────────────────────────────────────────────────────────────
    if (worker.role === 'Marketing') {
      return (
        <>
          <li><NavLink to="/voice-chat"          className={navLinkClass}><FaMicrophoneAlt /><span>Voice Chat</span></NavLink></li>
          <li><NavLink to="/user-face"            className={navLinkClass}><FaRegSmileBeam /><span>Face Attendance</span></NavLink></li>
          <li><NavLink to="/marketing-dashboard"  className={navLinkClass}><FaTachometerAlt /><span>My Report</span></NavLink></li>
          
          <li><NavLink to="/user-projects" className={navLinkClass}><FaProjectDiagram /><span>My Project</span></NavLink></li>
          <li><NavLink to="/user-attendance"      className={navLinkClass}><FaCalendarCheck /><span>My Attendance</span></NavLink></li>
          <li><NavLink to="/user-leave"           className={navLinkClass}><FaClipboardList /><span>My Leave Report</span></NavLink></li>
          <li><NavLink to="/user-profile"         className={navLinkClass}><FaUser /><span>Profile</span></NavLink></li>
<Divider />
          <SectionHeading label="Task Management" />
          <li><NavLink to="/marketing-assign-task"  className={navLinkClass}><FaTachometerAlt /><span>Assign Task</span></NavLink></li>
           <li><NavLink to="/marketing-projects"  className={navLinkClass}><FaTachometerAlt /><span>Assign Project</span></NavLink></li>
        </>
      );
    }

    // ── HR & Design ──────────────────────────────────────────────────────────
    if (worker.role === 'HR & Design') {
      return (
        <>
          {/* ── Personal ── */}
          <CommonItems />

          <Divider />

          {/* ── Section 1: HR Management ── */}
          <SectionHeading label="HR Management" />
           <li><NavLink to="/hr-design-task-manager"        className={navLinkClass}><FaClipboardList /><span>Create Task</span></NavLink></li>
          <li><NavLink to="/tasks"        className={navLinkClass}><FaTasks /><span>View Team Tasks</span></NavLink></li>
         
          <li><NavLink to="/user-projectss"      className={navLinkClass}><FaProjectDiagram /><span>View Team Projects</span></NavLink></li>
          {/* <li><NavLink to="/admin/assigned-locations"    className={navLinkClass}><FaBullhorn /><span>View Marketing Tasks</span></NavLink></li> */}
          <li><NavLink to="/marketing-members"   className={navLinkClass}><FaChartBar /><span>View Marketing Report</span></NavLink></li>
          <li><NavLink to="/office-attendance"    className={navLinkClass}><FaCalendarCheck /><span>Team Attendance</span></NavLink></li>
          <li><NavLink to="/office-leave"         className={navLinkClass}><FaClipboardList /><span>Team Leave Reports</span></NavLink></li>

          <Divider />

          {/* ── Section 2: Design ── */}
          <SectionHeading label="Design" />
          <li><NavLink to="/user-tasks"   className={navLinkClass}><FaTasks /><span>My Tasks</span></NavLink></li>
          <li><NavLink to="/user-projects" className={navLinkClass}><FaProjectDiagram /><span>My Project</span></NavLink></li>
          {/* <li><NavLink to="/design-report"  className={navLinkClass}><FaFileAlt /><span>Make Report</span></NavLink></li> */}
        </>
      );
    }

    // ── Project Leads ────────────────────────────────────────────────────────
    if (worker.role === 'Project Leads') {
      return (
        <>
          {/* ── Personal ── */}
          <CommonItems />
          <li><NavLink to="/user-tasks"    className={navLinkClass}><FaTasks /><span>My Task</span></NavLink></li>
          <li><NavLink to="/user-projects" className={navLinkClass}><FaProjectDiagram /><span>My Project</span></NavLink></li>

          <Divider />

          {/* ── Team (same as TL) ── */}
          <SectionHeading label="Team Management" />
          <li><NavLink to="/tasks"   className={navLinkClass}><FaProjectDiagram /><span>View Task Report</span></NavLink></li>
          <li><NavLink to="/user-projectss" className={navLinkClass}><FaProjectDiagram /><span>View All Projects</span></NavLink></li>
          <li><NavLink to="/pl-task-manager"      className={navLinkClass}><FaTasks /><span>Create Task</span></NavLink></li>
          <li><NavLink to="/pl-projects"   className={navLinkClass}><FaProjectDiagram /><span>Create Project</span></NavLink></li>
          <li><NavLink to="/team-attendance" className={navLinkClass}><FaCalendarCheck /><span>Team Attendance</span></NavLink></li>
          <li><NavLink to="/team-leave"      className={navLinkClass}><FaClipboardList /><span>Team Leave Reports</span></NavLink></li>
          
        </>
      );
    }

    return null;
  };

  return (
    <>
      {/* Overlay */}
      {isOpen && (
        <div onClick={onClose} className="fixed inset-0 bg-black bg-opacity-10 z-[9998]" />
      )}

      {/* Sidebar */}
      <div
        className={`fixed top-0 left-0 h-full w-64 bg-gradient-to-b from-white via-purple-50 to-pink-50 shadow-2xl transform transition-transform duration-300 z-[9999] ${
          isOpen ? 'translate-x-0' : '-translate-x-full'
        } overflow-y-auto`}
      >
        {/* Header */}
        <div className="flex justify-between items-center px-5 py-4 border-b border-purple-100 shadow-sm">
          <h2 className="text-2xl font-bold text-purple-700 font-mono">Dashboard</h2>
          <FaTimes className="cursor-pointer text-gray-500 hover:text-red-500 text-xl" onClick={onClose} />
        </div>

        {/* Menu */}
        <ul className="p-4 space-y-1 text-base font-medium">
          {renderMenu()}

          {/* Logout */}
          <li className="pt-4 border-t border-purple-200">
            <button
              onClick={() => setShowLogoutConfirm(true)}
              className="flex items-center space-x-3 px-4 py-3 rounded-md text-red-600 hover:bg-red-100 hover:text-red-700 transition-all duration-200 w-full"
            >
              <FaSignOutAlt className="text-lg" />
              <span>Logout</span>
            </button>
          </li>
        </ul>
      </div>

      {/* Logout Modal */}
      {showLogoutConfirm && (
        <div className="fixed inset-0 bg-black bg-opacity-40 backdrop-blur-sm z-[10000] flex items-center justify-center">
          <div className="bg-white rounded-lg shadow-lg p-6 w-80 text-center">
            <h2 className="text-xl font-bold text-gray-800 mb-4">Are you sure you want to logout?</h2>
            <div className="flex justify-center space-x-4">
              <button onClick={handleLogout} className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600">Yes</button>
              <button onClick={() => setShowLogoutConfirm(false)} className="px-4 py-2 bg-gray-300 text-gray-700 rounded hover:bg-gray-400">Cancel</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Sidebar;